<template>
  <div class="footer">
    <div class="container">
      <br />
      <br />
      <div class="row">
        <div class="col-md-3 footer-vestbee">
          <a :href="LANDING_URL"
            ><img
              alt="Vestbee"
              src="/static/images/vestbee_logo_light.png"
              width="105"
          /></a>
          <p>
            © {{ year }}, Vestbee<br />
            All rights reserved.<br />
            <span class="invisible">
              Design by
              <a href="http://rysownik.com/design" target="_new_rysownik"
                >Rysownik.com</a
              >
            </span>
          </p>
          <div class="footer-social">
            <a href="https://www.facebook.com/vestbeeplatform/" target="_new"
              ><span class="icon icon-fb"></span
            ></a>
            <a href="https://twitter.com/vestbee_com" target="_new"
              ><span class="icon icon-twitter"></span
            ></a>
            <a href="" class="hidden"><span class="icon icon-google"></span></a>
          </div>
        </div>
        <div class="col-md-9 footer-disclaimer">
          <p>
            The material presented via this website is for informational
            purposes only. Nothing in this website constitutes a solicitation
            for the purchase or sale of any financial product or service.
            Material presented on this website does not constitute a public
            offering of securities or investment management services in any
            jurisdiction. Investing in startup and early stage companies
            involves risks, including loss of capital, illiquidity, lack of
            dividends and dilution, and it should be done only as part of a
            diversified portfolio.
          </p>
          <p>
            The Investments presented in this website are suitable only for
            investors who are sufficiently sophisticated to understand these
            risks and make their own investment decisions.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalSettings from 'GlobalSettings'

export default {
  computed: {
    LANDING_URL: () => GlobalSettings.LANDING_URL,
    year: () => new Date().getFullYear(),
  },
}
</script>

<style lang="scss"></style>
